
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal-stylists",
      function () {
        return require("private-next-pages/personal-stylists/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal-stylists"])
      });
    }
  